import React from "react";
import "../css/privacy.scss";
import PolicyPage from "./PolicyPage";

function Privacy() {
  return (
    <PolicyPage title="Privacy Policy">
      <p><em>Last updated: October 9, 2026</em></p>
      <p>danecay respects your privacy. This policy explains what information we collect through this store, why we use it, when it may be shared, and the choices available to you.</p>

      <h2>1. Information We Collect</h2>
      <p>We collect information you provide at checkout or when contacting us, including your name, email address, billing and delivery address, country, postal code, order contents and customer-service messages. We do not ask you to enter card details on this website; payment information is collected directly by the payment provider after you select Pay Now.</p>

      <h2>2. Technical and Cookie Data</h2>
      <p>Our site may receive device type, browser type, IP address, approximate region, pages viewed, referral source and cookie identifiers. We use this data to keep the site working, protect transactions, remember cart choices and understand general site performance. Please see our Cookie Policy for more detail.</p>

      <h2>3. How We Use Information</h2>
      <p>We use personal information to process and deliver orders, collect payment, provide order updates, respond to questions, manage returns, prevent fraud, meet legal obligations and improve the usability of the store. We do not use checkout details to send unsolicited marketing.</p>

      <h2>4. Legal Grounds</h2>
      <p>Depending on the context, processing is necessary to perform our sales contract with you, comply with law, protect our legitimate interests in secure store operation, or act on consent where consent is required.</p>

      <h2>5. Service Providers</h2>
      <p>We may share only the information needed with payment processors, hosting providers, security vendors, fulfilment partners, carriers and professional advisers. These parties may use the information only to provide their services or meet their own legal duties.</p>

      <h2>6. International Processing</h2>
      <p>danecay operates from Hong Kong. Some service providers may process information in other locations. Where required, we use contractual or other appropriate safeguards for those transfers.</p>

      <h2>7. Retention and Security</h2>
      <p>We retain order records for as long as reasonably needed for fulfilment, customer service, fraud prevention, accounting and legal obligations. We use administrative and technical safeguards, but no internet system can guarantee absolute security.</p>

      <h2>8. Your Choices and Rights</h2>
      <p>You may request access, correction or deletion of personal information, or object to or restrict certain uses, subject to applicable exceptions. You can also manage optional cookies through your browser. We may need to verify your identity before completing a request.</p>

      <h2>9. Children</h2>
      <p>This store is intended for adults able to enter a purchase contract. We do not knowingly collect personal information from children.</p>

      <h2>10. Changes and Contact</h2>
      <p>We may update this policy when our practices or legal duties change. The revision date above shows the latest version. For privacy questions or requests, email <a href="mailto:core@danecay.shop">core@danecay.shop</a>.</p>
    </PolicyPage>
  );
}

export default Privacy;
